import { SignUpTranslation } from "@/AutoEnrollment/ui/autoEnrollmentTranslation"
import { handleErrors } from "@/Shared/ui/form"
import { OreHeading, OreInput, OreMessageBar, OreStack, OreText } from "@edenredespana/oreneta"
import { useFormContext } from "react-hook-form"
import { Trans, useTranslation } from "react-i18next"
import { IndentifyForm } from "../hooks"
import { formTranslation } from "@/Shared/ui/sharedTranslation"
import { LoginTranslation } from "../accountTranslation"
import { openNavigationRoutes } from "@/Shared/ui/routers"

interface CreateAccountIdentifyFormProps {
  isBlocked: boolean
  errorMessage: string
}

export const CreateAccountIdentifyForm = ({ isBlocked, errorMessage }: CreateAccountIdentifyFormProps): JSX.Element => {
  const { t } = useTranslation()

  const { register, formState } =
    useFormContext<IndentifyForm>()
  const { errors } = handleErrors(formState)

  return (
    <OreStack placeContent="stretch" space="medium">
      <OreHeading as="h2" size="headline-md">
        {t(LoginTranslation.recovery.form.title)}
      </OreHeading>
      <OreText size="text-md" tone="neutral-600">
        <Trans t={t} components={
          [
            <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}`} />
          ]
        }>
          {t(LoginTranslation.register.identifyForm.subtitle, {
            CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
          })}
        </Trans>
      </OreText>
      <OreInput
        {...register('backOfficeCompanyId')}
        {...errors('backOfficeCompanyId')}
        id="backOfficeCompanyId"
        label={t(formTranslation.common.identifier.merchantId.label)}
        labelTooltip={t(formTranslation.common.identifier.merchantId.tooltip)}
        placeholder={t(formTranslation.common.identifier.merchantId.placeholder)}
        required
        disabled={isBlocked}
        minLength={4}
      />
      <OreInput
        {...register('legalId')}
        {...errors('legalId')}
        id="legalId"
        label={t(formTranslation.common.identifier.legalId.label)}
        placeholder={t(formTranslation.common.identifier.legalId.placeholder)}
        legend={t(formTranslation.common.identifier.legalId.legend)}
        required
        disabled={isBlocked}
        maxLength={9}
      />
      {isBlocked && (
        <OreMessageBar>
          {errorMessage}
        </OreMessageBar>
      )}
      <OreText>{t(formTranslation.common.requiredFields)}</OreText>
      {formState.errors.root && !isBlocked && (
        <OreMessageBar>
          <Trans t={t} components={
            [
              <a href={openNavigationRoutes.login} />,
              <a href={openNavigationRoutes.passwordRecoveryStep1} />
            ]
          }>
            {t(formTranslation.errors.affiliateAlreadyHasAccount)}
          </Trans>
        </OreMessageBar>
      )}
    </OreStack>
  )
}